import triggerCustom from '../events/triggerCustom';

export const localStorageEvents = {
  updated: 'KHS.localStorage.updated',
  added: 'KHS.localStorage.added',
  removed: 'KHS.localStorage.added'
};

export const LOCAL_WATCHLIST_ID = 'khsWatchlistList';

export const getLocalWatchlist = () => {
  const stored = JSON.parse(window.localStorage.getItem(LOCAL_WATCHLIST_ID) as string);
  return stored || { articles: {} };
};

export const getLocalWatchlistCount = () => {
  const stored = getLocalWatchlist();
  return (
    Object.keys(stored.articles).length
  );
};

export const getLocalIsActive = (id: string) => {
  const stored = getLocalWatchlist();
  return stored.articles[id] || false;
};

export const removeLocalWatchlist = (id: string) => {
  const updatedStorage = getLocalWatchlist();
  const updatedStorageType = updatedStorage.articles;

  delete updatedStorageType[id];
  updatedStorage.articles = {
    ...updatedStorageType
  };

  window.localStorage.setItem(
    LOCAL_WATCHLIST_ID,
    JSON.stringify(updatedStorage)
  );
};

export const addLocalWatchlist = (id: string, title: string) => {
  const updatedStorage = getLocalWatchlist();
  const updatedStorageType = updatedStorage.articles;

  updatedStorage.articles = {
    ...updatedStorageType,
    [id]: { title }
  };

  window.localStorage.setItem(
    LOCAL_WATCHLIST_ID,
    JSON.stringify(updatedStorage)
  );
};

export const updateLocalStorage = (id: string, title = '', add = true) => {
  if (add) {
    addLocalWatchlist(id, title);
    triggerCustom(window, localStorageEvents.added, { id });
  } else {
    removeLocalWatchlist(id);
    triggerCustom(window, localStorageEvents.removed, { id });
  }
  triggerCustom(window, localStorageEvents.updated, { id });
};
